module.exports = __webpack_public_path__ + "img/Patch3-20170710.378ab016.webp";